import { SelectMui } from 'src/components/SelectMui'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: .7rem;
  padding-left: 1rem;
`

export const CustomRemovePrinterButton = styled.button`
  border-style: none;
  color: red;
  background: none;
  font-size: small;
  font-weight: bold;
  padding-left: 4px;
  padding-right: 4px;
`

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px;
  gap: 12px;
`

export const ComponentContainer = styled.div`
  display: flex;
  justify-content: start;
  height: 70vh;
`

export const CustomSelect = styled(SelectMui)`
  width: 20rem;
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #C4C4C4;
`
